import React from 'react';
import { Button } from '@mui/material';
import { Dashboard } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface BackToDashboardButtonProps {
  /** Button variant - defaults to 'outlined' */
  variant?: 'text' | 'outlined' | 'contained';
  /** Button size - defaults to 'small' */
  size?: 'small' | 'medium' | 'large';
  /** Custom label text - defaults to 'Back to Dashboard' */
  label?: string;
  /** Additional styling */
  sx?: object;
  /** Custom click handler - if not provided, navigates to home */
  onClick?: () => void;
}

/**
 * Reusable "Back to Dashboard" button component
 * Provides consistent navigation back to the home dashboard across pages
 */
export const BackToDashboardButton: React.FC<BackToDashboardButtonProps> = ({
  variant = 'outlined',
  size = 'small',
  label = 'Back to Dashboard',
  sx = {},
  onClick
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/');
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      startIcon={<Dashboard />}
      onClick={handleClick}
      sx={{
        color: '#3b82f6',
        borderColor: '#3b82f6',
        '&:hover': {
          backgroundColor: '#f0f9ff',
          borderColor: '#2563eb',
          color: '#2563eb'
        },
        fontWeight: 500,
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default BackToDashboardButton;